import { Injectable } from '@angular/core';
import { RestRequestService } from '../restApi/rest-request.service';
import {
  REST_CONTRACTOR,
  REST_CONTRACTOR_FAVORITE,
} from '../restApi/RestRoutes';
import { CurrentUserService } from './current-user.service';
import { Router } from '@angular/router';
import { ErrorHandlerRest } from '../restApi/errorHandler-rest';

@Injectable({
  providedIn: 'root',
})
export class ContractorsApiService extends ErrorHandlerRest {
  constructor(
    private rest: RestRequestService,
    protected user: CurrentUserService,
    protected router: Router,
  ) {
    super(user, router);
  }


  updateContractor(data, id = null) {
    return new Promise<any>((res, rej) => {
      this.rest.put(REST_CONTRACTOR + '/' + id, data).then(
        (dataRes) => {
          res(dataRes);
        },
        (err) => {
          rej(this.handleError(err));
        },
      );
    });
  }

  setFavoriteWithObservable(contracotrId: number, isFavorite: boolean) {
    const body = {
      is_favorite: isFavorite,
    };

    return this.rest.putWithObservable(`${REST_CONTRACTOR_FAVORITE}/${contracotrId}`, body);
  }
}
